// extracted by mini-css-extract-plugin
export default {"container":"ninthModule_container__9Gvy9","title":"ninthModule_title__iVm9j","description":"ninthModule_description__lxaxT"};